import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  section: {
    width: '100%',
    marginBottom: theme.spacing(3),
    padding: theme.spacing(4),
    background: '#ffffff',
    borderRadius: 12,
    border: '1px solid rgba(0, 0, 0, 0.08)',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
  },
  sectionTitle: {
    fontSize: '1.1rem',
    fontWeight: 600,
    color: '#122056',
    marginBottom: theme.spacing(1.5),
    paddingBottom: theme.spacing(1),
    borderBottom: '2px solid #5B65DC',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
      marginBottom: theme.spacing(1),
    },
  },
  sectionContent: {
    marginTop: theme.spacing(2),
    maxWidth: 1000,
    width: '100%',
  },
  // Allow custom styles to be passed
  customSection: {},
  customTitle: {},
  customContent: {},
}));

const FormSection = ({ 
  title, 
  children, 
  className,
  titleClassName,
  contentClassName,
  sectionStyles,
  titleStyles,
  contentStyles,
}) => {
  const classes = useStyles();

  return (
    <div 
      className={`${classes.section} ${className || ''}`}
      style={sectionStyles}
    >
      {title && (
        <Typography 
          className={`${classes.sectionTitle} ${titleClassName || ''}`}
          style={titleStyles}
        >
          {title}
        </Typography>
      )}
      <div 
        className={`${classes.sectionContent} ${contentClassName || ''}`}
        style={contentStyles}
      >
        {children}
      </div>
    </div>
  );
};

FormSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  sectionStyles: PropTypes.object,
  titleStyles: PropTypes.object,
  contentStyles: PropTypes.object,
};

FormSection.defaultProps = {
  title: null,
  className: '',
  titleClassName: '',
  contentClassName: '',
  sectionStyles: {},
  titleStyles: {},
  contentStyles: {},
};

export default FormSection;